<template>
    <div>
        <osobe-navigation
            :id="osoba_id"
            :breadcrumbs="breadcrumbs"
        >
        </osobe-navigation>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Grupe statusa</h5><br>
                <button
                    type="button"
                    class="btn btn-lg btn-primary"
                    @click.prevent="create"
                >
                    Novi unos
                </button>
            </div>
            <div class="ibox-content">
                <datatables
                    v-if="show_datatable"
                    :url="datatables_url"
                    :settings="datatables.settings"
                    :title="datatables.title"
                    @rowClick="rowClick"
                >
                </datatables>
            </div>
        </div>
    </div>
</template>

<script>
import Datatables from "../../../../components/datatable/Datatables";
import OsobeNavigation from "../OsobeNavigation";
export default {
    name: "OsobaGrupaStatusa",
    components: { OsobeNavigation, Datatables },
    data(){
        return {
            show_datatable: false,
            datatables_url: process.env.VUE_APP_API_URL +  'osoba-grupa-statusa',
            datatables: {},
            breadcrumbs: [],
            osoba_id: this.$route.params.osoba_id
        }
    },
    methods:{
        rowClick( row ){
            this.$router.push( { path: '/osobe/' + this.osoba_id + '/grupe-statusa/' + row.id } )
        },

        create(){
            this.$router.push( { path: '/osobe/' + this.osoba_id + '/grupe-statusa/create' } )
        },

        setDatatable() {
            let vm = this;
            vm.datatables = {
                settings: {
                    table_header:[
                        {
                            'id': 'id',
                            'visible': false,
                        },
                        {
                            'id': 'osoba_id',
                            'visible': false,
                            'filter':{
                                'type': 'none',
                                'value': vm.osoba_id
                            },
                        },
                        {
                            'id': 'naziv',
                            'title': 'Naziv',
                            'type' : function( row ){
                                return row.grupa_statusa ? row.grupa_statusa.naziv : 'null'
                            },
                            'column_visibility_group': {
                                'id': 'osoba-grupa-statusa',
                                'visible' : true
                            }
                        },
                        {
                            'id': 'datum_od',
                            'title': 'Od',
                            'type' : 'text',
                            'column_visibility_group': {
                                'id': 'osoba-grupa-statusa',
                                'visible' : true
                            },
                            'filter': {
                                'type': 'date',
                            }
                        },
                        {
                            'id': 'datum_do',
                            'title': 'Do',
                            'type' : 'text',
                            'column_visibility_group': {
                                'id': 'osoba-grupa-statusa',
                                'visible' : true
                            },
                            'filter': {
                                'type': 'date',
                            }
                        }


                    ],
                    column_visibility_groups:{
                        'osoba-grupa-statusa' : 'Grupa statusa'
                    },
                    order: 'desc',
                    order_by: 'id',
                },
                title: 'Grupa statusa',
            }
            vm.show_datatable = true;
        },

        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/osobe/' + this.osoba_id + '/grupa-statusa',
                    name: 'Grupe statusa'
                }
            ]
        }
    },
    mounted() {
        this.setDatatable()
        this.setBreadcrumbs()
    }
}
</script>

<style scoped>

</style>
